var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversationViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "See_message",
    "data-name": "See message",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 321.999,
    height: 239.96,
    viewBox: "0 0 321.999 239.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1673",
    "data-name": "Rectangle 1673",
    width: 321.999,
    height: 239.96,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1651",
    "data-name": "Rectangle 1651",
    width: 15.59,
    height: 20.595,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1652",
    "data-name": "Rectangle 1652",
    width: 4.891,
    height: 5.711,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1653",
    "data-name": "Rectangle 1653",
    width: 7.113,
    height: 6.442,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1654",
    "data-name": "Rectangle 1654",
    width: 29.907,
    height: 44.834,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1655",
    "data-name": "Rectangle 1655",
    width: 5.413,
    height: 21.574,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1656",
    "data-name": "Rectangle 1656",
    width: 6.647,
    height: 7.444,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1657",
    "data-name": "Rectangle 1657",
    width: 4.824,
    height: 5.446,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1658",
    "data-name": "Rectangle 1658",
    width: 4.756,
    height: 37.195,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1659",
    "data-name": "Rectangle 1659",
    width: 16.161,
    height: 21.801,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1661",
    "data-name": "Rectangle 1661",
    width: 116.517,
    height: 76.212,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1664",
    "data-name": "Rectangle 1664",
    width: 113.858,
    height: 38.27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1665",
    "data-name": "Rectangle 1665",
    width: 81.163,
    height: 59.408,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1666",
    "data-name": "Rectangle 1666",
    width: 67.836,
    height: 38.473,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1667",
    "data-name": "Rectangle 1667",
    width: 22.172,
    height: 16.803,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1668",
    "data-name": "Rectangle 1668",
    width: 13.055,
    height: 13.616,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1669",
    "data-name": "Rectangle 1669",
    width: 2.362,
    height: 3.619,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4810",
    "data-name": "Group 4810",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1612",
    "data-name": "Rectangle 1612",
    width: 321.999,
    height: 0.161,
    transform: "translate(0 210.875)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1613",
    "data-name": "Rectangle 1613",
    width: 21.331,
    height: 0.161,
    transform: "translate(67.327 215.26)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1614",
    "data-name": "Rectangle 1614",
    width: 26.242,
    height: 0.161,
    transform: "translate(110.214 221.16)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1615",
    "data-name": "Rectangle 1615",
    width: 32.899,
    height: 0.16,
    transform: "translate(33.784 219.143)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1616",
    "data-name": "Rectangle 1616",
    width: 59.981,
    height: 0.161,
    transform: "translate(229.754 216.342)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1617",
    "data-name": "Rectangle 1617",
    width: 4.078,
    height: 0.161,
    transform: "translate(219.942 216.342)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1618",
    "data-name": "Rectangle 1618",
    width: 27.197,
    height: 0.16,
    transform: "translate(178.525 219.062)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4749",
    "data-name": "Group 4749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4748",
    "data-name": "Group 4748",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M166.238,182.153H41.883a3.68,3.68,0,0,1-3.676-3.676V3.676A3.68,3.68,0,0,1,41.883,0H166.238a3.68,3.68,0,0,1,3.675,3.676v174.8a3.68,3.68,0,0,1-3.675,3.676M41.883.161a3.519,3.519,0,0,0-3.515,3.515v174.8a3.519,3.519,0,0,0,3.515,3.515H166.238a3.519,3.519,0,0,0,3.514-3.515V3.676A3.519,3.519,0,0,0,166.238.161Z",
    transform: "translate(-13.602 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    d: "M382.536,182.153H258.18a3.679,3.679,0,0,1-3.675-3.676V3.676A3.68,3.68,0,0,1,258.18,0H382.536a3.68,3.68,0,0,1,3.676,3.676v174.8a3.68,3.68,0,0,1-3.676,3.676M258.18.161a3.518,3.518,0,0,0-3.514,3.515v174.8a3.518,3.518,0,0,0,3.514,3.515H382.536a3.519,3.519,0,0,0,3.515-3.515V3.676A3.519,3.519,0,0,0,382.536.161Z",
    transform: "translate(-90.604 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1619",
    "data-name": "Rectangle 1619",
    width: 52.002,
    height: 129.557,
    transform: "translate(96.37 81.318)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1620",
    "data-name": "Rectangle 1620",
    width: 46.293,
    height: 38.138,
    transform: "translate(99.224 84.567)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1621",
    "data-name": "Rectangle 1621",
    width: 46.293,
    height: 38.138,
    transform: "translate(99.224 126.128)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1622",
    "data-name": "Rectangle 1622",
    width: 46.293,
    height: 38.138,
    transform: "translate(99.224 167.688)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1623",
    "data-name": "Rectangle 1623",
    width: 18.208,
    height: 38.138,
    transform: "translate(127.308 84.567)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1624",
    "data-name": "Rectangle 1624",
    width: 18.208,
    height: 38.138,
    transform: "translate(127.308 126.128)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1625",
    "data-name": "Rectangle 1625",
    width: 12.613,
    height: 15.234,
    transform: "translate(106.544 149.032)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1626",
    "data-name": "Rectangle 1626",
    width: 5.325,
    height: 15.234,
    transform: "translate(101.219 149.032)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1627",
    "data-name": "Rectangle 1627",
    width: 12.613,
    height: 15.234,
    transform: "translate(126.921 149.032)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1628",
    "data-name": "Rectangle 1628",
    width: 5.325,
    height: 15.234,
    transform: "translate(121.595 149.032)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1629",
    "data-name": "Rectangle 1629",
    width: 12.613,
    height: 15.234,
    transform: "translate(116.955 133.797)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1630",
    "data-name": "Rectangle 1630",
    width: 5.325,
    height: 15.234,
    transform: "translate(111.629 133.797)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1631",
    "data-name": "Rectangle 1631",
    width: 18.208,
    height: 38.138,
    transform: "translate(127.308 167.688)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1632",
    "data-name": "Rectangle 1632",
    width: 14.12,
    height: 129.557,
    transform: "translate(82.25 81.318)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1633",
    "data-name": "Rectangle 1633",
    width: 37.588,
    height: 32.639,
    transform: "translate(104.786 173.186)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1634",
    "data-name": "Rectangle 1634",
    width: 5.562,
    height: 32.639,
    transform: "translate(99.224 173.186)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1635",
    "data-name": "Rectangle 1635",
    width: 37.588,
    height: 32.639,
    transform: "translate(104.786 90.065)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1636",
    "data-name": "Rectangle 1636",
    width: 5.562,
    height: 32.639,
    transform: "translate(99.224 90.065)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1637",
    "data-name": "Rectangle 1637",
    width: 89.592,
    height: 189.807,
    transform: "translate(184.752 21.068)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1638",
    "data-name": "Rectangle 1638",
    width: 0.336,
    height: 189.807,
    transform: "translate(184.416 21.068)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1639",
    "data-name": "Rectangle 1639",
    width: 73.133,
    height: 183.576,
    transform: "translate(191.23 27.299)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1640",
    "data-name": "Rectangle 1640",
    width: 75.218,
    height: 183.576,
    transform: "translate(193.06 27.299)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    "data-name": "Path 1740",
    d: "M408.07,187.291V189.6l2.312-2.311Z",
    transform: "translate(-145.273 -66.676)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1641",
    "data-name": "Rectangle 1641",
    width: 64.255,
    height: 172.612,
    transform: "translate(198.541 32.781)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1741",
    "data-name": "Path 1741",
    d: "M388.537,185.827a1.777,1.777,0,1,0,0,3.554h11.25v-3.554Z",
    transform: "translate(-137.687 -66.155)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    d: "M330.18,223.514,349.791,50.9H363l-19.61,172.612Z",
    transform: "translate(-117.545 -18.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1743",
    "data-name": "Path 1743",
    d: "M355.1,223.514,374.712,50.9h5.151L360.251,223.514Z",
    transform: "translate(-126.416 -18.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1642",
    "data-name": "Rectangle 1642",
    width: 0.696,
    height: 172.612,
    transform: "translate(262.1 32.781)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1744",
    "data-name": "Path 1744",
    d: "M403.512,185.713h-11.25a1.777,1.777,0,1,1,0-3.554h11.25a1.777,1.777,0,1,1,0,3.554",
    transform: "translate(-139.013 -64.849)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1643",
    "data-name": "Rectangle 1643",
    width: 31.611,
    height: 50.289,
    transform: "translate(41.196 43.08)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1644",
    "data-name": "Rectangle 1644",
    width: 32.685,
    height: 50.289,
    transform: "translate(42.028 43.08)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1645",
    "data-name": "Rectangle 1645",
    width: 27.208,
    height: 42.955,
    transform: "translate(44.766 46.747)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1646",
    "data-name": "Rectangle 1646",
    width: 31.611,
    height: 50.289,
    transform: "translate(85.835 18.816)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1647",
    "data-name": "Rectangle 1647",
    width: 32.685,
    height: 50.289,
    transform: "translate(86.667 18.816)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1648",
    "data-name": "Rectangle 1648",
    width: 27.208,
    height: 42.955,
    transform: "translate(89.405 22.482)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4751",
    "data-name": "Group 4751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4750",
    "data-name": "Group 4750",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1745",
    "data-name": "Path 1745",
    d: "M305.84,357.255c0,4.028-55.9,7.292-124.864,7.292s-124.864-3.264-124.864-7.292,55.9-7.292,124.864-7.292,124.864,3.265,124.864,7.292",
    transform: "translate(-19.976 -124.587)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4780",
    "data-name": "Group 4780"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4779",
    "data-name": "Group 4779",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1746",
    "data-name": "Path 1746",
    d: "M160.609,70.282c1.385,1.832,1.553,4.089.063,7.694-.618,1.493-1.48,2.953-3.35.448s-3.471-7.056-.663-7.485,3.95-.657,3.95-.657",
    transform: "translate(-55.23 -25.02)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1747",
    "data-name": "Path 1747",
    d: "M162.7,345.81h4.784l.2-11.079h-4.784Z",
    transform: "translate(-57.923 -119.164)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1748",
    "data-name": "Path 1748",
    d: "M107.539,333.1l4.637,1.178,4.8-10.212-4.637-1.179Z",
    transform: "translate(-38.284 -114.947)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1749",
    "data-name": "Path 1749",
    d: "M111.37,338.845l-5.091-1.724a.405.405,0,0,0-.483.182l-2.16,3.758a.723.723,0,0,0,.41,1.038c1.787.571,2.684.758,4.922,1.516,1.378.466,5.305,2.115,7.208,2.759,1.86.63,2.741-1.168,2.016-1.6-3.252-1.953-5.371-4-6.173-5.395a1.186,1.186,0,0,0-.648-.53",
    transform: "translate(-36.861 -120.008)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1750",
    "data-name": "Path 1750",
    d: "M166.482,351.074h-5.225a.4.4,0,0,0-.4.327l-.841,4.253a.715.715,0,0,0,.709.851c1.884-.032,4.605-.142,6.974-.142,2.77,0,3.349.151,6.6.151,1.964,0,2.461-1.986,1.634-2.166-3.763-.819-5-.907-8.288-2.9a2.26,2.26,0,0,0-1.162-.373",
    transform: "translate(-56.961 -124.983)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1751",
    "data-name": "Path 1751",
    d: "M168.133,115.8l6.529-2.094s6.746,15.626,9.006,16.6c3.075,1.32,5.483,3.489,9.433,3.885a6.99,6.99,0,0,1,1.325,3.308c-5.3,2-13.464-.118-15.715-2.2-5.132-4.748-10.577-19.494-10.577-19.494",
    transform: "translate(-59.856 -40.479)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1752",
    "data-name": "Path 1752",
    d: "M165.6,109.656c-1.837,4.189,5.535,17.48,5.535,17.48l9.761-4.52a60.565,60.565,0,0,0-4.839-11.682c-3.067-5.328-8.441-5.875-10.457-1.278",
    transform: "translate(-58.849 -37.929)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4754",
    "data-name": "Group 4754",
    transform: "translate(106.457 68.612)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4753",
    "data-name": "Group 4753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4752",
    "data-name": "Group 4752",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1753",
    "data-name": "Path 1753",
    d: "M165.6,109.656c-1.837,4.189,5.535,17.48,5.535,17.48l9.761-4.52a60.565,60.565,0,0,0-4.839-11.682c-3.067-5.328-8.441-5.875-10.457-1.278",
    transform: "translate(-165.306 -106.541)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1754",
    "data-name": "Path 1754",
    d: "M205.662,144.428l3.683-1.91,1.873,5.413s-1.2.535-4.643.111Z",
    transform: "translate(-73.216 -50.737)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    d: "M215.051,140.381l1.175,4.625-2.973,2.164-1.872-5.413Z",
    transform: "translate(-75.252 -49.976)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4757",
    "data-name": "Group 4757",
    transform: "translate(104.878 215.569)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4756",
    "data-name": "Group 4756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4755",
    "data-name": "Group 4755",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    d: "M167.746,334.735l-.1,5.711h-4.786l.1-5.711Z",
    transform: "translate(-162.855 -334.735)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4760",
    "data-name": "Group 4760",
    transform: "translate(71.574 207.939)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4759",
    "data-name": "Group 4759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4758",
    "data-name": "Group 4758",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M113.614,322.887l4.639,1.178-2.474,5.264-4.639-1.179Z",
    transform: "translate(-111.14 -322.887)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    d: "M160.65,106.339s6,16.441,1.3,43.346h-25.59c-.272-3.928,1.726-25.084-2.517-43.593a66.114,66.114,0,0,1,8.54-1.082,94.082,94.082,0,0,1,10.878,0,48.67,48.67,0,0,1,7.392,1.328",
    transform: "translate(-47.647 -37.327)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4763",
    "data-name": "Group 4763",
    transform: "translate(86.193 67.524)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4762",
    "data-name": "Group 4762"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4761",
    "data-name": "Group 4761",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    d: "M160.65,106.339s6,16.441,1.3,43.346h-25.59c-.272-3.928,1.726-25.084-2.517-43.593a66.114,66.114,0,0,1,8.54-1.082,94.082,94.082,0,0,1,10.878,0,48.67,48.67,0,0,1,7.392,1.328",
    transform: "translate(-133.84 -104.851)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4766",
    "data-name": "Group 4766",
    transform: "translate(86.592 70.517)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4765",
    "data-name": "Group 4765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4764",
    "data-name": "Group 4764",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    d: "M139.731,112.316c.5,3.045-.281,10.334-2.976,18.756a122.585,122.585,0,0,0-2.295-21.484v-.036c1.682-.173,4.793-.091,5.271,2.765",
    transform: "translate(-134.46 -109.498)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    "data-name": "Path 1761",
    d: "M148.273,89.3c.772,3.5,1.219,7.838-1.173,10.174,0,0,1.494,3.55,8,3.55,5.943,0,2.881-3.55,2.881-3.55-3.926-.932-3.841-5.759-3.228-8.478Z",
    transform: "translate(-52.368 -31.791)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    "data-name": "Path 1762",
    d: "M154.482,107.867a6.841,6.841,0,0,0-1.166,3.362s-8.215-2.874-7.939-7.083c0,0,1.139-.687,1.86-1.244,0,0,.346,3.28,7.244,4.966",
    transform: "translate(-51.752 -36.633)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    d: "M159.519,108.283a12.819,12.819,0,0,1,1.675,3.109s3.629-2.5,2.419-6.659a14.155,14.155,0,0,0-2.1-.663s.555,3.312-1.993,4.213",
    transform: "translate(-56.789 -37.049)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4769",
    "data-name": "Group 4769",
    transform: "translate(95.906 57.51)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4768",
    "data-name": "Group 4768"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4767",
    "data-name": "Group 4767",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    d: "M155.4,91a10.49,10.49,0,0,0,.167,5.746,6.365,6.365,0,0,1-1.756-.535c-2.226-1.039-3.351-2.671-4.54-5.093-.1-.621-.22-1.228-.351-1.815Z",
    transform: "translate(-148.923 -89.302)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    d: "M165.725,85.643a4.37,4.37,0,0,1-2.528,2.286c-1.483.5-2.332-.834-2.01-2.3.29-1.319,1.411-3.168,2.942-3.032a2.08,2.08,0,0,1,1.6,3.046",
    transform: "translate(-57.358 -29.402)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4772",
    "data-name": "Group 4772",
    transform: "translate(103.76 53.187)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4771",
    "data-name": "Group 4771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4770",
    "data-name": "Group 4770",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1766",
    "data-name": "Path 1766",
    d: "M165.725,85.643a4.37,4.37,0,0,1-2.528,2.286c-1.483.5-2.332-.834-2.01-2.3.29-1.319,1.411-3.168,2.942-3.032a2.08,2.08,0,0,1,1.6,3.046",
    transform: "translate(-161.119 -82.589)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1767",
    "data-name": "Path 1767",
    d: "M145.48,77.257c.873,4.712,1.149,7.51,3.811,9.7,4.005,3.288,9.509.511,10.039-4.34.478-4.366-1.03-11.338-5.841-12.745a6.329,6.329,0,0,0-8.009,7.389",
    transform: "translate(-51.749 -24.775)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1768",
    "data-name": "Path 1768",
    d: "M146.693,72.9c1.088,2.022.517,3.338-.973,6.942-.618,1.493-1.663,3.08-3.35.448-1.593-2.484-4.021-7.108-1.913-7.589a16.246,16.246,0,0,1,6.237.2",
    transform: "translate(-49.71 -25.798)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1769",
    "data-name": "Path 1769",
    d: "M145.15,71.006a3.035,3.035,0,0,0,3.829-1.252c1.544.682,3.572.774,4.23-.106,1.261,0,2.667.234,3.284-1.607s-.142-3.5-2.168-4.431c-.045.408-1.094.942-2.078.263a3.282,3.282,0,0,0-3.568.218c-2.105-.547-3.6-.849-4.8.535-2.007-.418-4.447,1.4-4.112,2.972-1.571,1.953-.05,3.537,1.558,3.812.323.823,3.4.413,3.829-.405",
    transform: "translate(-49.521 -22.587)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1770",
    "data-name": "Path 1770",
    d: "M142.979,88.087A4.59,4.59,0,0,0,146,89.79c1.567.18,2.069-1.3,1.4-2.656-.6-1.226-2.148-2.8-3.608-2.345a2.026,2.026,0,0,0-.811,3.3",
    transform: "translate(-50.714 -30.157)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1771",
    "data-name": "Path 1771",
    d: "M151.367,174.469s.509,6.014,1.156,14.171c.737,9.239,1.645,21.235,2.188,30.377,0,.046.006.086.006.124.1,1.737.2,3.363.267,4.852.725,14.908,2.221,58.293,2.221,58.293h8.1s4.082-44.274,4.252-59.449c.163-14.588-1.372-48.368-1.372-48.368Z",
    transform: "translate(-53.887 -62.111)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1772",
    "data-name": "Path 1772",
    d: "M159.5,337.85c-.037,0,.065,2.648.065,2.648h9.342l.32-2.975Z",
    transform: "translate(-56.779 -120.159)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4775",
    "data-name": "Group 4775",
    transform: "translate(98.636 119.835)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4774",
    "data-name": "Group 4774"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4773",
    "data-name": "Group 4773",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1773",
    "data-name": "Path 1773",
    d: "M153.162,192.772c.738,9.24,1.645,21.235,2.188,30.377,0,.046.006.085.006.124,1.985-8.666,2.788-19.447,2.508-37.195Z",
    transform: "translate(-153.162 -186.079)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1774",
    "data-name": "Path 1774",
    d: "M143.988,174.469s-4.533,34.57-7.178,48.268c-2.9,15-19.424,53.226-19.424,53.226l-8.493-2.158s12.1-34.857,13.6-49.708c1.626-16.119,4.986-49.628,4.986-49.628Z",
    transform: "translate(-38.766 -62.111)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1775",
    "data-name": "Path 1775",
    d: "M109.147,325.26c-.036-.009-.968,2.28-.968,2.28l9.335,2.372,1.452-2.531Z",
    transform: "translate(-38.512 -115.793)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1776",
    "data-name": "Path 1776",
    d: "M156.808,81.982c.047.386.287.678.536.652s.412-.36.364-.746-.288-.678-.537-.652-.412.36-.364.746",
    transform: "translate(-55.821 -28.92)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1777",
    "data-name": "Path 1777",
    d: "M163.49,81.282c.048.386.288.678.537.652s.411-.36.364-.746-.288-.678-.537-.652-.412.361-.364.746",
    transform: "translate(-58.2 -28.67)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    d: "M161.407,82.216a14.331,14.331,0,0,0,2.227,3.112,2.162,2.162,0,0,1-1.776.536Z",
    transform: "translate(-57.461 -29.269)",
    fill: "#ed847e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1779",
    "data-name": "Path 1779",
    d: "M159.036,88.922a.111.111,0,0,0,.094-.128.117.117,0,0,0-.129-.1,3.085,3.085,0,0,1-2.634-.858.112.112,0,0,0-.159-.012.115.115,0,0,0-.008.161,3.271,3.271,0,0,0,2.836.936",
    transform: "translate(-55.597 -31.256)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1780",
    "data-name": "Path 1780",
    d: "M154.389,79.608a.216.216,0,0,0,.167-.109,1.742,1.742,0,0,1,1.339-.907.223.223,0,0,0,.213-.236.233.233,0,0,0-.238-.22,2.167,2.167,0,0,0-1.7,1.126.232.232,0,0,0,.082.313.221.221,0,0,0,.14.032",
    transform: "translate(-54.873 -27.817)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1781",
    "data-name": "Path 1781",
    d: "M165.149,78.231a.218.218,0,0,0,.093-.039.228.228,0,0,0,.046-.318,2.28,2.28,0,0,0-1.827-.994.22.22,0,0,0-.211.238.232.232,0,0,0,.238.218,1.819,1.819,0,0,1,1.439.8.229.229,0,0,0,.223.093",
    transform: "translate(-58.117 -27.369)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1782",
    "data-name": "Path 1782",
    d: "M126.048,117.88l6.162,3.3s-7.016,15.207-6.1,17.468c1.244,3.077,3.212,9.875,5.343,13.225a6.626,6.626,0,0,1-1.855,2.967c-4.912-3.025-10.569-13.348-10.668-16.353-.227-6.852,7.119-20.609,7.119-20.609",
    transform: "translate(-42.337 -41.965)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1783",
    "data-name": "Path 1783",
    d: "M128.693,106.73c-4.511.658-9.31,16.343-9.31,16.343l9.639,5.37a113.164,113.164,0,0,0,5.933-13c2.022-5.8-1.424-9.419-6.262-8.713",
    transform: "translate(-42.5 -37.965)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4778",
    "data-name": "Group 4778",
    transform: "translate(76.883 68.677)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4777",
    "data-name": "Group 4777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4776",
    "data-name": "Group 4776",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1784",
    "data-name": "Path 1784",
    d: "M128.693,106.73c-4.511.658-9.31,16.343-9.31,16.343l9.639,5.37a113.164,113.164,0,0,0,5.933-13c2.022-5.8-1.424-9.419-6.262-8.713",
    transform: "translate(-119.383 -106.642)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1785",
    "data-name": "Path 1785",
    d: "M116.98,341.287a1.423,1.423,0,0,0,.945.063.665.665,0,0,0,.4-.5.372.372,0,0,0-.088-.368c-.415-.426-2.164-.018-2.362.03a.112.112,0,0,0-.083.093.118.118,0,0,0,.054.115,5.689,5.689,0,0,0,1.134.565m.968-.717a.324.324,0,0,1,.131.074.143.143,0,0,1,.028.15.453.453,0,0,1-.269.344,2.287,2.287,0,0,1-1.634-.463,4.464,4.464,0,0,1,1.743-.1",
    transform: "translate(-41.222 -121.144)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1786",
    "data-name": "Path 1786",
    d: "M115.869,339.988a.116.116,0,0,0,.055,0c.549-.1,1.767-.792,1.83-1.335a.38.38,0,0,0-.254-.4.606.606,0,0,0-.5-.016c-.661.256-1.18,1.538-1.2,1.592a.115.115,0,0,0,.017.116.118.118,0,0,0,.053.037m1.491-1.543a.387.387,0,0,1,.048.02c.135.064.126.133.123.162-.037.32-.85.881-1.428,1.08.173-.368.557-1.087.981-1.251a.4.4,0,0,1,.276-.011",
    transform: "translate(-41.222 -120.398)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1787",
    "data-name": "Path 1787",
    d: "M172.3,351.7a1.781,1.781,0,0,0,1.155-.294.62.62,0,0,0,.2-.552.369.369,0,0,0-.194-.3c-.589-.327-2.488.651-2.7.763a.109.109,0,0,0-.057.117.117.117,0,0,0,.092.1,8.217,8.217,0,0,0,1.508.171m.842-.99a.452.452,0,0,1,.213.042.139.139,0,0,1,.074.121.406.406,0,0,1-.128.364,3.046,3.046,0,0,1-2.135.13,6.123,6.123,0,0,1,1.976-.658",
    transform: "translate(-60.768 -124.774)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1788",
    "data-name": "Path 1788",
    d: "M170.813,350.912a.128.128,0,0,0,.046-.01c.571-.26,1.69-1.294,1.589-1.835-.023-.126-.118-.285-.43-.316a.8.8,0,0,0-.623.194,3.165,3.165,0,0,0-.7,1.843.118.118,0,0,0,.05.1.115.115,0,0,0,.066.021m1.12-1.94c.022,0,.045,0,.068,0,.2.021.22.1.224.128.061.325-.7,1.137-1.277,1.491a2.586,2.586,0,0,1,.6-1.475.588.588,0,0,1,.39-.148",
    transform: "translate(-60.768 -124.153)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1789",
    "data-name": "Path 1789",
    d: "M135.51,169.71l4.536.462-3.132,4.548s-3.955-.536-4.143-3.666Z",
    transform: "translate(-47.266 -60.417)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1790",
    "data-name": "Path 1790",
    d: "M144.893,172.183l-3.04,3.974-2.648-1.182,3.132-4.548Z",
    transform: "translate(-49.557 -60.672)",
    fill: "#ffc3bd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4809",
    "data-name": "Group 4809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4808",
    "data-name": "Group 4808",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1791",
    "data-name": "Path 1791",
    d: "M338.275,165.342l4.482,52.219c.364,4.249-2.236,7.974-5.779,8.278l-99.084,8.5c-3.543.3-6.739-2.923-7.1-7.172l-4.481-52.219a8.9,8.9,0,0,1,.225-2.924c.712-2.915,2.859-5.122,5.553-5.354l99.084-8.5c2.689-.231,5.186,1.578,6.384,4.323a8.93,8.93,0,0,1,.721,2.85",
    transform: "translate(-80.554 -56.302)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4783",
    "data-name": "Group 4783",
    transform: "translate(145.72 101.848)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4782",
    "data-name": "Group 4782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4781",
    "data-name": "Group 4781",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1792",
    "data-name": "Path 1792",
    d: "M338.275,165.342l4.482,52.219c.364,4.249-2.236,7.974-5.779,8.278l-99.084,8.5c-3.543.3-6.739-2.923-7.1-7.172l-4.481-52.219a8.9,8.9,0,0,1,.225-2.924c.712-2.915,2.859-5.122,5.553-5.354l99.084-8.5c2.689-.231,5.186,1.578,6.384,4.323a8.93,8.93,0,0,1,.721,2.85",
    transform: "translate(-226.274 -158.15)"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1662",
    "data-name": "Rectangle 1662",
    width: 0.706,
    height: 2.369,
    transform: "matrix(0.993, -0.12, 0.12, 0.993, 268.793, 139.879)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1663",
    "data-name": "Rectangle 1663",
    width: 0.706,
    height: 8.827,
    transform: "translate(267.42 128.525) rotate(-6.893)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1793",
    "data-name": "Path 1793",
    d: "M343.563,150.858l6.477,53.553c.527,4.357-2.014,8.282-5.647,8.722L242.777,225.423c-3.633.44-7.037-2.766-7.564-7.124l-6.477-53.552a9.174,9.174,0,0,1,.127-3.016c.629-3.024,2.758-5.371,5.521-5.705L336,143.734c2.758-.334,5.391,1.438,6.721,4.218a9.2,9.2,0,0,1,.843,2.906",
    transform: "translate(-81.405 -51.155)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4786",
    "data-name": "Group 4786",
    transform: "translate(147.456 92.539)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4785",
    "data-name": "Group 4785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4784",
    "data-name": "Group 4784",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1794",
    "data-name": "Path 1794",
    d: "M342.828,147.952l-46.092,31.036a17.024,17.024,0,0,1-15.611,1.888L228.969,161.73c.629-3.024,2.758-5.371,5.522-5.705l101.616-12.291c2.758-.334,5.391,1.438,6.721,4.218",
    transform: "translate(-228.97 -143.694)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    d: "M334.2,147.842l-13.244,8.914-4.33,2.919L305.3,167.3a16.952,16.952,0,0,1-15.2,2.024c-.134-.035-.268-.084-.4-.134l-6.354-2.334-14.295-5.247-6.685-2.454-7.574-2.779-.543-13.392-1.206-29.753,58.173-2.362,22.172,16.8.232,5.712Z",
    transform: "translate(-90.083 -39.469)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4789",
    "data-name": "Group 4789",
    transform: "translate(162.958 71.398)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4788",
    "data-name": "Group 4788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4787",
    "data-name": "Group 4787",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    d: "M334.2,147.842l-13.244,8.914-4.33,2.919L305.3,167.3a16.952,16.952,0,0,1-15.2,2.024c-.134-.035-.268-.084-.4-.134l-6.354-2.334-14.295-5.247-6.685-2.454-7.574-2.779-.543-13.392-1.206-29.753,58.173-2.362,22.172,16.8.232,5.712Z",
    transform: "translate(-253.041 -110.867)",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4792",
    "data-name": "Group 4792",
    transform: "translate(170.094 91.38)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4791",
    "data-name": "Group 4791"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4790",
    "data-name": "Group 4790",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1797",
    "data-name": "Path 1797",
    d: "M329.947,144.636l-64.4,2.615a1.371,1.371,0,0,1-.111-2.74l64.4-2.615a1.371,1.371,0,1,1,.111,2.74",
    transform: "translate(-264.122 -141.895)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1798",
    "data-name": "Path 1798",
    d: "M330.486,157.921l-64.4,2.615a1.371,1.371,0,0,1-.111-2.74l64.4-2.615a1.371,1.371,0,1,1,.111,2.74",
    transform: "translate(-264.314 -146.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1799",
    "data-name": "Path 1799",
    d: "M331.026,171.2l-64.4,2.615a1.372,1.372,0,0,1-.111-2.741l64.4-2.615a1.371,1.371,0,0,1,.111,2.74",
    transform: "translate(-264.506 -151.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1800",
    "data-name": "Path 1800",
    d: "M326.113,182.122l-4.33,2.92L274.2,186.974l-6.685-2.454a.688.688,0,0,1,.169-.021Z",
    transform: "translate(-265.331 -156.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    "data-name": "Path 1801",
    d: "M320.088,197.943v.05a1.38,1.38,0,0,1-1.312,1.382l-11.925.48c-.134-.035-.268-.085-.4-.134l-6.354-2.335,18.568-.755a1.376,1.376,0,0,1,1.424,1.312",
    transform: "translate(-276.928 -161.381)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4795",
    "data-name": "Group 4795",
    transform: "translate(221.132 71.401)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4794",
    "data-name": "Group 4794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4793",
    "data-name": "Group 4793",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1802",
    "data-name": "Path 1802",
    d: "M365.546,127.673l-15.407-.665-6.765-16.137Z",
    transform: "translate(-343.373 -110.871)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1803",
    "data-name": "Path 1803",
    d: "M365.546,127.673,350.6,125.111l-7.224-14.241Z",
    transform: "translate(-122.241 -39.47)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1804",
    "data-name": "Path 1804",
    d: "M405.561,31.191c0,13.094-14.353,25.967-16.506,25.967s-16.506-12.873-16.506-25.967c0-8.783,7.39-15.9,16.506-15.9s16.506,7.119,16.506,15.9",
    transform: "translate(-132.628 -5.443)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4798",
    "data-name": "Group 4798",
    transform: "translate(243.182 12.345)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4797",
    "data-name": "Group 4797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4796",
    "data-name": "Group 4796",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1805",
    "data-name": "Path 1805",
    d: "M387.793,29.3c-2.987,3.279-7.044,4.448-9.062,2.61s-1.233-5.987,1.754-9.266,7.044-4.448,9.062-2.61,1.233,5.987-1.754,9.266",
    transform: "translate(-377.612 -19.169)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4801",
    "data-name": "Group 4801",
    transform: "translate(244.32 33.485)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4800",
    "data-name": "Group 4800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4799",
    "data-name": "Group 4799",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1806",
    "data-name": "Path 1806",
    d: "M379.618,54.184c-.393-.977-.29-1.938.23-2.148s1.261.413,1.655,1.39.29,1.938-.231,2.148-1.261-.413-1.654-1.39",
    transform: "translate(-379.379 -51.996)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1807",
    "data-name": "Path 1807",
    d: "M396.939,121.258a.264.264,0,0,1-.265-.264,4.051,4.051,0,0,1,.744-2.428,3.8,3.8,0,0,0,0-4.3,4.331,4.331,0,0,1,0-4.854,3.791,3.791,0,0,0,0-4.3,4.324,4.324,0,0,1,0-4.849,3.791,3.791,0,0,0,0-4.3,4.324,4.324,0,0,1,0-4.849,3.79,3.79,0,0,0,0-4.295,4.323,4.323,0,0,1,0-4.849,3.542,3.542,0,0,0,.667-2.146.264.264,0,1,1,.528,0,4.04,4.04,0,0,1-.744,2.424,3.79,3.79,0,0,0,0,4.294,4.322,4.322,0,0,1,0,4.85,3.791,3.791,0,0,0,0,4.294,4.323,4.323,0,0,1,0,4.851,3.791,3.791,0,0,0,0,4.294,4.323,4.323,0,0,1,0,4.851,3.8,3.8,0,0,0,0,4.3,4.331,4.331,0,0,1,0,4.856,3.558,3.558,0,0,0-.667,2.15.264.264,0,0,1-.263.264",
    transform: "translate(-141.216 -28.326)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1808",
    "data-name": "Path 1808",
    d: "M396.034,79.35c-.506,0-3.88,3.026-3.88,6.1h7.76c0-3.078-3.374-6.1-3.88-6.1",
    transform: "translate(-139.607 -28.249)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1809",
    "data-name": "Path 1809",
    d: "M398.4,80.115h-1.524a.224.224,0,0,1-.223-.223v-.163a.224.224,0,0,1,.223-.223H398.4a.224.224,0,0,1,.223.223v.163a.224.224,0,0,1-.223.223",
    transform: "translate(-141.208 -28.304)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1810",
    "data-name": "Path 1810",
    d: "M244.709,50.194c0,13.094-14.353,25.967-16.506,25.967S211.7,63.288,211.7,50.194c0-8.783,7.39-15.9,16.506-15.9s16.506,7.119,16.506,15.9",
    transform: "translate(-75.364 -12.208)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4804",
    "data-name": "Group 4804",
    transform: "translate(140.007 25.117)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4803",
    "data-name": "Group 4803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4802",
    "data-name": "Group 4802",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1811",
    "data-name": "Path 1811",
    d: "M227.584,49.137c-2.987,3.279-7.044,4.448-9.062,2.61s-1.233-5.987,1.754-9.266,7.044-4.448,9.062-2.61,1.233,5.987-1.754,9.266",
    transform: "translate(-217.403 -39.001)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4807",
    "data-name": "Group 4807",
    transform: "translate(141.145 46.257)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4806",
    "data-name": "Group 4806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4805",
    "data-name": "Group 4805",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1812",
    "data-name": "Path 1812",
    d: "M219.409,74.016c-.393-.977-.29-1.938.231-2.148s1.261.413,1.654,1.39.29,1.938-.23,2.148-1.261-.413-1.654-1.39",
    transform: "translate(-219.17 -71.827)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1813",
    "data-name": "Path 1813",
    d: "M236.087,140.261a.264.264,0,0,1-.264-.265,4.054,4.054,0,0,1,.744-2.427,3.8,3.8,0,0,0,0-4.3,4.331,4.331,0,0,1,0-4.854,3.794,3.794,0,0,0,0-4.3,4.324,4.324,0,0,1,0-4.849,3.794,3.794,0,0,0,0-4.3,4.324,4.324,0,0,1,0-4.849,3.793,3.793,0,0,0,0-4.295,4.323,4.323,0,0,1,0-4.849,3.542,3.542,0,0,0,.667-2.146.264.264,0,0,1,.529,0,4.041,4.041,0,0,1-.744,2.424,3.791,3.791,0,0,0,0,4.294,4.322,4.322,0,0,1,0,4.85,3.792,3.792,0,0,0,0,4.294,4.323,4.323,0,0,1,0,4.851,3.792,3.792,0,0,0,0,4.294,4.323,4.323,0,0,1,0,4.851,3.8,3.8,0,0,0,0,4.3,4.331,4.331,0,0,1,0,4.856,3.557,3.557,0,0,0-.667,2.15.264.264,0,0,1-.264.265",
    transform: "translate(-83.953 -35.091)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1814",
    "data-name": "Path 1814",
    d: "M235.183,98.353c-.506,0-3.88,3.026-3.88,6.1h7.76c0-3.078-3.374-6.1-3.88-6.1",
    transform: "translate(-82.344 -35.014)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1815",
    "data-name": "Path 1815",
    d: "M237.545,99.117H236.02a.224.224,0,0,1-.223-.223V98.73a.224.224,0,0,1,.223-.223h1.524a.224.224,0,0,1,.223.223v.163a.224.224,0,0,1-.223.223",
    transform: "translate(-83.944 -35.069)",
    fill: "#407bff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationViewIcon);
export default __webpack_public_path__ + "static/media/conversation-view-icon.02c0555eff656fb67f3d0a0419f84727.svg";
export { ForwardRef as ReactComponent };